// Client-side request budget — mirrors the backend's rate limiter (see
// backend/src/app.js, currently 300 req / 15 min per IP) so the FRONTEND
// takes responsibility for never tripping it, rather than a polling loop
// firing blindly and the user eating a 429. Every outgoing request is
// recorded here (see the interceptor in ./api.js); every polling loop checks
// canPoll() before firing and simply skips that tick if the budget is tight,
// leaving headroom for the requests that actually matter — the ones a user is
// sitting there waiting on (clicking Generate, Publish, etc.), which are never
// gated by this module, only discretionary background polling is.
const WINDOW_MS = 15 * 60 * 1000;

// Kept a real margin under the server's actual ceiling (300): this budget is
// the *soft* limit background polling respects, so user-initiated actions
// always have room even if every polling loop in the app happened to be
// active at once.
const SAFE_BUDGET = 220;

const timestamps = [];

function pruneOld() {
  const cutoff = Date.now() - WINDOW_MS;
  let i = 0;
  while (i < timestamps.length && timestamps[i] < cutoff) i++;
  if (i > 0) timestamps.splice(0, i);
}

// Called by the axios interceptor for every request that actually goes out —
// this is what makes the budget reflect real traffic (user actions included),
// not just polling, so polling correctly backs off when the user themselves
// is generating heavy traffic too.
export function recordRequest() {
  pruneOld();
  timestamps.push(Date.now());
}

// Polling loops call this before firing their tick. Returns false once
// within the safety margin of the server's real limit — the loop should just
// skip that tick (its own setInterval will naturally retry next cycle).
export function canPoll() {
  pruneOld();
  return timestamps.length < SAFE_BUDGET;
}

export function budgetRemaining() {
  pruneOld();
  return Math.max(0, SAFE_BUDGET - timestamps.length);
}
